import { RDLiming } from '@cibo/core'
import { LimingCellDisplay } from '../CellDisplays'
import { TraitCellDisplayProps } from '../types'

export const LimingCell = ({ traitId, year, params }: TraitCellDisplayProps<RDLiming>) => {
  const detail = params.row.findDetail({ traitId, year })
  return <LimingCellDisplay value={detail?.value} />
}
